import { render, staticRenderFns } from "./MediaCategoryList.vue?vue&type=template&id=a18b988c&scoped=true"
import script from "./MediaCategoryList.vue?vue&type=script&lang=js"
export * from "./MediaCategoryList.vue?vue&type=script&lang=js"
import style0 from "./MediaCategoryList.vue?vue&type=style&index=0&id=a18b988c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18b988c",
  null
  
)

export default component.exports